/* Mykotheke – mješavina: boca se puni dok kupac bira gljive (prenijeto iz mockupa v3, app.js).
   Treba mk.js (window.MK.add). Scena s pretakanjem je u mk-scene.js. */
(() => {
const ICON = { plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' };
// boja tečnosti po pilzu (prirodna boja ekstrakta); nepoznat pilz dobije boju iz rezervne palete
const COLORS = [[/reishi|ganoderma/i, "#8a2d1c"], [/igel|hericium/i, "#eadfc3"], [/chaga|inonotus/i, "#2f221c"], [/cordyceps|raupen/i, "#e0892c"],
  [/mandel|agaricus/i, "#cfb07c"], [/maitake|grifola/i, "#6b774a"], [/zunder|fomes/i, "#8d9396"], [/shiitake|lentinula/i, "#a5683f"],
  [/schopf|coprinus/i, "#3e4757"], [/schmetterling|coriolus|trametes v/i, "#6f6a86"], [/huaier|trametes r/i, "#b7a77a"], [/polyporus|eichhase/i, "#9a8061"],
  [/auricularia|judasohr/i, "#4b2b26"], [/austern|pleurotus/i, "#b9b2a4"], [/tremella|silber/i, "#e6dcc0"], [/hexen|flammulina|enoki/i, "#d9b86c"]];
const SPARE = ["#7a5c3e", "#5d6b52", "#9c6b4e", "#45503f", "#b08a5a"];
// lista iz metapolja: „Reishi (Ganoderma l.)“ → ime „Reishi“, latinski „Ganoderma l.“, a cijeli tekst ide u korpu
const RAW = JSON.parse(document.querySelector("[data-blend] [data-sorts]")?.textContent || "[]");
const SORTS = RAW.map((full, i) => {
  const m = full.match(/^(.*?)\s*\((.*)\)\s*$/);
  // prikaz ispravlja tipfelere iz metapolja („Schopftinling“, „Inotus“); u korpu ide originalni tekst
  const fix = (x) => x.replace(/Schopftinling/, "Schopftintling").replace(/Inotus/, "Inonotus");
  const name = fix((m ? m[1] : full).trim()), lat = fix(m ? m[2].trim() : "");
  const c = (COLORS.find(([re]) => re.test(full)) || [0, SPARE[i % SPARE.length]])[1];
  return [name, lat, c, full];
});
const SORT = Object.fromEntries(SORTS.map(([n, lat, c, full], i) => [n, { lat, c, i, full }]));
const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const tint = (hex, k) => "#" + rgb(hex).map((v) => Math.round(k > 0 ? v + (255 - v) * k : v * (1 + k)).toString(16).padStart(2, "0")).join("");
const light = (hex) => { const [r, g, b] = rgb(hex).map((v) => v / 255).map((v) => (v <= 0.04 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4)); return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.28; };
const X_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg>';

function initBlend() {
  const root = document.querySelector("[data-blend]");
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const NS = "http://www.w3.org/2000/svg";
  const mk = (tag, attrs = {}) => { const el = document.createElementNS(NS, tag); for (const k in attrs) el.setAttribute(k, attrs[k]); return el; };
  const svg = $(".bottle"), stage = $("[data-stage]"), rowsEl = $("[data-rows]"), pick = $("[data-pick]"), pickNote = $("[data-pick-note]");
  const status = $("[data-status]"), buy = $("[data-buy]"), even = $("[data-even]"), nameIn = $("[data-name]");
  const hlFrame = root.querySelectorAll("[data-hl-frame]");
  const liquid = $("[data-liquid]"), lines = $("[data-bounds]"), surface = $("[data-surface]"), bubbleG = $("[data-bubbles]");
  const labelG = $("[data-labels]"), freeT = $("[data-free]"), knobG = $("[data-knobs]");
  const tag = $("[data-tag]"), tagName = $("[data-tag-name]"), tagBar = $("[data-tag-bar]"), caustic = $("[data-caustic]");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const available = root.dataset.available === "true";

  const STEP = 5, MAX = 100, MAXN = 5;
  const BOTTOM = 474, PX = 3.06, X0 = 60, X1 = 240; // unutrašnjost boce: 100 ml = 306 jedinica, puna do ramena (y 168)
  // početni primjer (odozdo prema gore): Reishi, Igelstachelbart, Chaga, ako su u listi
  let sel = [["Reishi", 40], ["Igelstachelbart", 35], ["Chaga", 25]].filter(([n]) => SORT[n]);
  if (sel.length < 3) sel = SORTS.slice(0, 3).map(([n], k) => [n, [40, 35, 25][k]]);

  const total = () => sel.reduce((s, [, ml]) => s + ml, 0);
  const get = (n) => sel.find((s) => s[0] === n);
  const cum = (i) => sel.slice(0, i + 1).reduce((s, [, ml]) => s + ml, 0);
  const list = () => sel.map(([n, ml]) => `${n} ${ml} ml`).join(", ");
  const say = (t) => { status.textContent = t; };

  // gradijenti po sorti: svjetlije gore, tamnije dole
  const defs = $("[data-defs]");
  SORTS.forEach(([, , c], i) => {
    const g = mk("linearGradient", { id: `lq${i}`, x1: 0, y1: 0, x2: 0, y2: 1 });
    g.append(mk("stop", { offset: 0, "stop-color": tint(c, 0.12) }), mk("stop", { offset: 1, "stop-color": tint(c, -0.14) }));
    defs.append(g);
  });

  /* --- animacija: opruga po sorti, talas na površini, mjehurići, ljuljanje etikete --- */
  const anim = new Map(sel.map(([n, ml]) => [n, { x: ml, v: 0 }]));
  let order = sel.map(([n]) => n);
  const layerEl = new Map(), labelEl = new Map();
  const wave = { a: 0, p: 0 }, swing = { x: 0, v: 0 };
  let bubbles = [], raf = 0, last = 0, hl = null;

  const wavePath = (top, yb) => {
    let d = `M${X0} ${yb}V${top.toFixed(2)}`, line = "";
    for (let x = X0; x <= X1; x += 6) {
      const y = top + wave.a * (0.6 * Math.sin((x - X0) / 19 + wave.p) + 0.4 * Math.sin((x - X0) / 9 - wave.p * 1.4));
      d += `L${x} ${y.toFixed(2)}`; line += `${line ? "L" : "M"}${x} ${y.toFixed(2)}`;
    }
    return [d + `V${yb}Z`, line];
  };

  const render = () => {
    const vis = order.filter((n) => anim.get(n).x > 0.01);
    const tops = {};
    let base = BOTTOM, lineD = "";
    vis.forEach((n, i) => { const top = base - anim.get(n).x * PX; tops[n] = [top, base]; if (i < vis.length - 1) lineD += `M66 ${top.toFixed(2)}H234`; base = top; });
    // slojevi: najgornji prvi u DOM-u, svaki ide do dna, pa nema pukotina između slojeva
    vis.slice().reverse().forEach((n, k) => {
      let el = layerEl.get(n);
      if (!el) { el = mk("path", { class: "layer", fill: `url(#lq${SORT[n].i})`, "data-n": n }); layerEl.set(n, el); }
      if (liquid.children[k] !== el) liquid.insertBefore(el, liquid.children[k] || null);
      const [top] = tops[n];
      if (k === 0) { const [d, line] = wavePath(top, BOTTOM + 14); el.setAttribute("d", d); surface.setAttribute("d", line); }
      else el.setAttribute("d", `M${X0} ${BOTTOM + 14}V${top.toFixed(2)}H${X1}V${BOTTOM + 14}Z`);
    });
    if (!vis.length) surface.setAttribute("d", "");
    lines.setAttribute("d", lineD);
    // okvir oko sloja koji je istaknut (red ili pokazivač na sloju)
    const f = hl && tops[hl] ? `M${X0} ${Math.min(BOTTOM + 14, tops[hl][1] === BOTTOM ? BOTTOM + 14 : tops[hl][1]).toFixed(2)}V${tops[hl][0].toFixed(2)}H${X1}V${(tops[hl][1] === BOTTOM ? BOTTOM + 14 : tops[hl][1]).toFixed(2)}Z` : "";
    hlFrame.forEach((el) => el.setAttribute("d", f));
    // natpisi u tečnosti
    labelEl.forEach((t, n) => { if (!tops[n]) t.style.display = "none"; });
    vis.forEach((n) => {
      let t = labelEl.get(n);
      if (!t) { t = mk("text", { x: 92 }); t.append(mk("tspan", { class: "l-name" }), mk("tspan", { class: "l-ml" })); labelEl.set(n, t); labelG.append(t); t.setAttribute("fill", light(SORT[n].c) ? "#24180f" : "#fff"); }
      const [top, bot] = tops[n], h = bot - top, mid = (top + bot) / 2, ml = Math.round(anim.get(n).x); // broji zajedno s nivoom
      const [a, b] = t.children;
      t.style.display = h < 19 || !get(n) ? "none" : "";
      a.textContent = n; b.textContent = `${ml} ml`;
      if (h >= 40) { a.setAttribute("x", 92); a.setAttribute("y", mid - 3); b.setAttribute("x", 92); b.setAttribute("y", mid + 13); b.removeAttribute("dx"); t.classList.remove("one"); }
      else { a.setAttribute("x", 92); a.setAttribute("y", mid + 4); b.removeAttribute("x"); b.setAttribute("y", mid + 4); b.setAttribute("dx", 6); t.classList.add("one"); }
    });
    // prazan prostor u boci
    const free = MAX - total(), shown = MAX - vis.reduce((s, n) => s + anim.get(n).x, 0);
    freeT.style.display = free >= 10 && shown >= 8 ? "" : "none";
    freeT.textContent = free === MAX ? "Leer: Pilze wählen" : `noch ${free} ml frei`;
    freeT.setAttribute("y", (base + (BOTTOM - MAX * PX)) / 2 + 5);
    // ručke na granicama
    // ručke na granicama; kad su dvije preblizu (tanak sloj), druga se pomakne ulijevo
    let prevY = Infinity, prevX = 0;
    sel.forEach(([n], i) => {
      const k = knobG.children[i]; if (!k) return;
      k.style.display = tops[n] ? "" : "none"; // sloj koji još čeka mlaz nema ručku
      if (!tops[n]) return;
      const y = tops[n][0], x = prevY - y < 20 && prevX === 206 ? 166 : 206;
      k.setAttribute("transform", `translate(${x} ${y.toFixed(2)})`); prevY = y; prevX = x;
    });
    // etiketa: mini traka s udjelima
    let x = 246;
    tagBar.innerHTML = vis.map((n) => { const w = (anim.get(n).x / MAX) * 72; const r = `<rect x="${x.toFixed(2)}" y="218" width="${Math.max(0, w).toFixed(2)}" height="6" fill="${SORT[n].c}"/>`; x += w; return r; }).join("") +
      `<rect x="246" y="218" width="72" height="6" rx="1.5" fill="none" stroke="#000" stroke-opacity=".18"/>`;
    tag.setAttribute("transform", `rotate(${(5 + swing.x).toFixed(2)} 282 150)`);
    // mjehurići
    bubbleG.innerHTML = bubbles.map((b) => `<circle cx="${b.x.toFixed(1)}" cy="${b.y.toFixed(1)}" r="${b.r}" fill="#fff" fill-opacity="${(0.55 * Math.min(1, b.life * 2)).toFixed(2)}"/>`).join("");
  };

  const tick = (t) => {
    const dt = last ? Math.min(0.033, (t - last) / 1000) : 0.016; last = t;
    let busy = false;
    for (const n of order) {
      const a = anim.get(n), target = get(n) ? get(n)[1] : 0;
      if (reduce) { a.x = target; a.v = 0; continue; }
      if (a.hold) { busy = true; continue; } // scena još sipa: nivo čeka mlaz
      const k = a.soft ? 55 : 240, c = a.soft ? 15 : 28; // meka opruga dok se puni iz mlaza
      a.v += (k * (target - a.x) - c * a.v) * dt; a.x += a.v * dt;
      if (Math.abs(target - a.x) > 0.02 || Math.abs(a.v) > 0.05) busy = true; else { a.x = target; a.v = 0; a.soft = false; }
    }
    order = order.filter((n) => {
      if (get(n) || anim.get(n).x > 0.01) return true;
      anim.delete(n); layerEl.get(n)?.remove(); layerEl.delete(n); labelEl.get(n)?.remove(); labelEl.delete(n); return false;
    });
    wave.a *= Math.exp(-dt * 2.4); wave.p += dt * 5;
    if (wave.a > 0.04) busy = true; else wave.a = 0;
    swing.v += (-90 * swing.x - 3.2 * swing.v) * dt; swing.x += swing.v * dt;
    if (Math.abs(swing.x) > 0.02 || Math.abs(swing.v) > 0.05) busy = true; else { swing.x = 0; swing.v = 0; }
    const surfaceY = BOTTOM - order.reduce((s, n) => s + anim.get(n).x, 0) * PX;
    bubbles = bubbles.filter((b) => { b.y -= b.s * dt; b.x += Math.sin(b.y / 9) * 0.25; b.life -= dt; return b.life > 0 && b.y > surfaceY + 3; });
    if (bubbles.length) busy = true;
    render();
    if (busy) raf = requestAnimationFrame(tick); else { raf = 0; last = 0; }
  };
  const kick = (splash = 2.2, sway = 0) => {
    if (!reduce) { wave.a = Math.min(6, wave.a + splash); swing.v += sway; }
    if (!raf) raf = requestAnimationFrame(tick);
  };
  const pour = (n) => {
    if (reduce) return;
    const top = BOTTOM - total() * PX;
    for (let k = 0; k < 7; k++) bubbles.push({ x: 84 + Math.random() * 130, y: top + 30 + Math.random() * 60, r: (1.2 + Math.random() * 2.2).toFixed(1), s: 45 + Math.random() * 50, life: 0.8 + Math.random() * 0.7 });
  };

  /* --- redovi (ključevani, da fokus ostane na dugmetu) --- */
  const canInc = (n) => total() < MAX || sel.some(([m, ml]) => m !== n && ml >= 2 * STEP);
  const rowHTML = (n) => `<span class="sw" style="--c:${SORT[n].c}"></span><span class="name">${n}<small>${SORT[n].lat}</small></span>
    <span class="stepper"><button type="button" data-dec aria-label="${n}: 5 ml weniger">−</button><output class="num"></output><button type="button" data-inc aria-label="${n}: 5 ml mehr">+</button></span>
    <button type="button" class="rm" data-rm aria-label="${n} entfernen">${X_ICON}</button>`;
  const drawRows = () => {
    const want = sel.slice().reverse().map(([n]) => n); // prvi red = gornji sloj, kao u boci
    [...rowsEl.children].forEach((li) => { if (!want.includes(li.dataset.n) && li.parentNode) li.remove(); });
    want.forEach((n, k) => {
      let li = [...rowsEl.children].find((x) => x.dataset.n === n);
      if (!li) { li = document.createElement("li"); li.className = "row is-new"; li.dataset.n = n; li.innerHTML = rowHTML(n); li.addEventListener("animationend", () => li.classList.remove("is-new"), { once: true }); }
      if (rowsEl.children[k] !== li) rowsEl.insertBefore(li, rowsEl.children[k] || null);
      const ml = get(n)[1];
      li.querySelector("output").textContent = `${ml} ml`;
      li.querySelector("[data-dec]").disabled = ml <= STEP;
      li.querySelector("[data-inc]").disabled = !canInc(n);
      li.classList.toggle("hl", hl === n);
    });
    if (!want.length) rowsEl.innerHTML = '<li class="empty-hint">Noch leer. Wählen Sie unten bis zu fünf Pilze, zusammen 100 ml.</li>';
  };
  const drawPick = () => {
    const full = sel.length >= MAXN;
    pick.innerHTML = SORTS.filter(([n]) => !get(n)).map(([n, , c]) => `<button type="button" class="chip add-chip" data-pick-n="${n}" ${full ? "disabled" : ""}><i style="--c:${c}"></i>${n}${ICON.plus}</button>`).join("");
    pickNote.textContent = full ? "Maximal fünf Sorten" : `noch ${MAXN - sel.length} möglich`;
  };
  const drawBuy = () => {
    const free = MAX - total();
    buy.dataset.mode = !sel.length ? "none" : free > 0 ? "fill" : "buy";
    buy.disabled = !sel.length || !available;
    buy.className = "btn " + (free > 0 && sel.length ? "btn-dark" : "btn-buy");
    buy.textContent = !available ? "Derzeit nicht verfügbar" : !sel.length ? "Zuerst Pilze wählen" : free > 0 ? `Noch ${free} ml auffüllen` : "In den Warenkorb";
    even.hidden = sel.length < 2;
  };
  const drawKnobs = () => {
    while (knobG.children.length > sel.length) knobG.lastChild.remove();
    while (knobG.children.length < sel.length) {
      const k = mk("g", { class: "knob", tabindex: 0, role: "slider", "data-i": knobG.children.length });
      k.append(mk("rect", { class: "hit", x: -142, y: -10, width: 172, height: 20 }), mk("rect", { class: "pill", x: -15, y: -6, width: 30, height: 12, rx: 6, filter: "url(#lift)" }), mk("path", { class: "grip", d: "M-6 -1.6H6M-6 1.6H6" }));
      knobG.append(k);
    }
    [...knobG.children].forEach((k, i) => {
      const [n, ml] = sel[i], nx = sel[i + 1];
      k.setAttribute("aria-label", nx ? `Grenze zwischen ${n} und ${nx[0]}` : `Füllstand ${n}`);
      k.setAttribute("aria-valuemin", 0); k.setAttribute("aria-valuemax", MAX); k.setAttribute("aria-valuenow", cum(i));
      k.setAttribute("aria-valuetext", nx ? `${n} ${ml} ml, ${nx[0]} ${nx[1]} ml` : `${n} ${ml} ml, ${MAX - total()} ml frei`);
    });
  };
  const commit = (msg, splash, sway) => {
    // redoslijed crtanja: sorte iz izbora, a one koje odlaze ostaju na svom mjestu dok ne nestanu
    const leaving = order.map((n, i) => [n, i]).filter(([n]) => !get(n));
    order = sel.map(([n]) => n);
    leaving.forEach(([n, i]) => order.splice(Math.min(i, order.length), 0, n));
    sel.forEach(([n]) => { if (!anim.has(n)) anim.set(n, { x: 0, v: 0 }); });
    drawRows(); drawPick(); drawBuy(); drawKnobs();
    caustic.style.fill = sel.length ? `rgb(${[0, 1, 2].map((c) => Math.round(sel.reduce((s, [n, ml]) => s + rgb(SORT[n].c)[c] * ml, 0) / (total() || 1))).join(",")})` : "transparent";
    if (msg) say(msg);
    kick(splash, sway);
    root.dispatchEvent(new CustomEvent("blend:change", { detail: { full: sel.length > 0 && total() === MAX } }));
  };
  const flash = (n) => { const li = [...rowsEl.children].find((x) => x.dataset.n === n); if (!li) return; li.classList.remove("flash"); void li.offsetWidth; li.classList.add("flash"); };

  /* --- radnje --- */
  const takeFromLargest = (need, except) => {
    while (need > 0) {
      const d = sel.filter(([n, ml]) => n !== except && ml > STEP).sort((a, b) => b[1] - a[1])[0];
      if (!d) break; d[1] -= STEP; need -= STEP;
    }
  };
  const add = (n) => {
    if (get(n) || sel.length >= MAXN) return;
    const free = MAX - total(), fair = Math.max(STEP, Math.round(MAX / (sel.length + 1) / STEP) * STEP);
    const ml = Math.max(free, fair);
    if (ml > free) takeFromLargest(ml - free, n);
    sel.push([n, Math.min(ml, MAX - total())]);
    if (root._scene && !reduce) {
      // scena (mischung-laden.html) ulije pilz iz boce; nivo raste tek kad mlaz stigne
      const a = { x: 0, v: 0, hold: true, soft: true };
      anim.set(n, a);
      root._scene.pour(n, SORT[n].c, () => { a.hold = false; kick(1.5); });
    } else pour(n);
    commit(`${n} hinzugefügt. ${list()}.`, 4, 26);
  };
  const remove = (n) => {
    sel = sel.filter((s) => s[0] !== n);
    commit(`${n} entfernt. ${sel.length ? `Noch ${MAX - total()} ml frei.` : "Die Flasche ist leer."}`, 3, -18);
  };
  const inc = (n) => {
    const s = get(n);
    if (total() < MAX) { s[1] += STEP; commit(`${n} ${s[1]} ml`, 1.4); return; }
    const d = sel.filter(([m, ml]) => m !== n && ml >= 2 * STEP).sort((a, b) => b[1] - a[1])[0];
    if (!d) return;
    s[1] += STEP; d[1] -= STEP;
    commit(`${n} ${s[1]} ml, dafür ${d[0]} ${d[1]} ml`, 1.4);
    flash(d[0]);
  };
  const dec = (n) => { const s = get(n); if (s[1] <= STEP) return; s[1] -= STEP; commit(`${n} ${s[1]} ml. Noch ${MAX - total()} ml frei.`, 1.4); };
  const evenOut = () => {
    const k = sel.length; if (!k) return;
    const base = Math.floor(MAX / k / STEP) * STEP; let rest = MAX - base * k;
    sel.forEach((s) => (s[1] = base));
    for (let i = sel.length - 1; rest > 0; i--, rest -= STEP) sel[i][1] += STEP;
    commit(`Gleichmäßig verteilt: ${list()}.`, 3, 10);
  };
  const fill = () => {
    let free = MAX - total(); const t = total(); if (!t || free <= 0) return;
    sel.forEach((s) => { const a = Math.floor((free * s[1]) / t / STEP) * STEP; s[1] += a; });
    free = MAX - total();
    const big = sel.slice().sort((a, b) => b[1] - a[1]);
    for (let i = 0; free > 0; i++, free -= STEP) big[i % big.length][1] += STEP;
    commit(`Aufgefüllt: ${list()}.`, 4, 14);
  };
  const moveBoundary = (i, s) => {
    const last = i === sel.length - 1, lo = (i ? cum(i - 1) : 0) + STEP, hi = last ? MAX : cum(i + 1) - STEP;
    s = Math.max(lo, Math.min(hi, s));
    const d = s - cum(i); if (!d) return;
    sel[i][1] += d; if (!last) sel[i + 1][1] -= d;
    commit("", Math.min(2, Math.abs(d) * 0.12));
  };

  rowsEl.addEventListener("click", (e) => {
    const li = e.target.closest(".row"); if (!li) return;
    const n = li.dataset.n;
    if (e.target.closest("[data-inc]")) inc(n);
    else if (e.target.closest("[data-dec]")) dec(n);
    else if (e.target.closest("[data-rm]")) {
      const next = li.nextElementSibling || li.previousElementSibling;
      remove(n);
      if (e.detail === 0) (next && next.isConnected ? next.querySelector("[data-rm]") : pick.querySelector("button"))?.focus();
    }
  });
  pick.addEventListener("click", (e) => {
    const b = e.target.closest("[data-pick-n]"); if (!b || b.disabled) return;
    add(b.dataset.pickN);
    if (e.detail === 0) [...rowsEl.children].find((x) => x.dataset.n === b.dataset.pickN)?.querySelector("[data-inc]")?.focus();
  });
  even.addEventListener("click", evenOut);
  // u korpu: ista svojstva kao u staroj temi (radnja ih tako čita), plus ime na etiketi ako ga kupac upiše
  buy.addEventListener("click", async () => {
    if (!sel.length || !available) return;
    if (total() < MAX) { fill(); return; }
    const props = {};
    sel.forEach(([n, ml], k) => { props[`Ingredient ${k + 1}`] = SORT[n].full; props[`Amount ${k + 1} (ml)`] = String(ml); });
    props["Total (ml)"] = String(total());
    const label = nameIn.value.trim();
    if (label) props["Name auf dem Etikett"] = label;
    buy.disabled = true;
    try { await window.MK.add([{ id: +root.dataset.variant, quantity: 1, properties: props }]); say(`Ihre Mischung ist im Warenkorb: ${list()}.`); }
    catch (err) { say("Die Mischung konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut."); }
    buy.disabled = false;
  });

  // povezivanje reda i sloja: pokazivač na jednom ističe drugi
  const setHl = (n) => {
    if (hl === n) return; hl = n;
    [...rowsEl.children].forEach((li) => li.classList.toggle("hl", !!n && li.dataset.n === n));
    render();
  };
  liquid.addEventListener("pointerover", (e) => setHl(e.target.dataset.n || null));
  liquid.addEventListener("pointerleave", () => setHl(null));
  rowsEl.addEventListener("pointerover", (e) => setHl(e.target.closest(".row")?.dataset.n || null));
  rowsEl.addEventListener("pointerleave", () => setHl(null));
  rowsEl.addEventListener("focusin", (e) => setHl(e.target.closest(".row")?.dataset.n || null));
  rowsEl.addEventListener("focusout", () => setHl(null));

  // povlačenje granica u boci (miš, dodir, tastatura)
  let drag = null;
  const ref = root.querySelector("[data-bottle-g]") || svg; // u sceni je boca pomjerena unutar većeg crteža
  const toMl = (e) => { const pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY; return (BOTTOM - pt.matrixTransform(ref.getScreenCTM().inverse()).y) / PX; };
  knobG.addEventListener("pointerdown", (e) => {
    const k = e.target.closest(".knob"); if (!k) return;
    e.preventDefault();
    drag = { k, i: +k.dataset.i, id: e.pointerId }; k.setPointerCapture(e.pointerId); k.classList.add("drag"); stage.classList.add("dragging");
  });
  knobG.addEventListener("pointermove", (e) => { if (drag && e.pointerId === drag.id) moveBoundary(drag.i, Math.round(toMl(e) / STEP) * STEP); });
  const end = () => { if (!drag) return; drag.k.classList.remove("drag"); stage.classList.remove("dragging"); const i = drag.i; drag = null; say(`${sel[i][0]} ${sel[i][1]} ml${sel[i + 1] ? `, ${sel[i + 1][0]} ${sel[i + 1][1]} ml` : ""}`); };
  knobG.addEventListener("pointerup", end); knobG.addEventListener("pointercancel", end);
  knobG.addEventListener("keydown", (e) => {
    const k = e.target.closest(".knob"); if (!k) return;
    const d = { ArrowUp: STEP, ArrowRight: STEP, ArrowDown: -STEP, ArrowLeft: -STEP, PageUp: 2 * STEP, PageDown: -2 * STEP }[e.key];
    if (!d) return; e.preventDefault(); moveBoundary(+k.dataset.i, cum(+k.dataset.i) + d);
  });

  // ime na etiketi
  const fitName = () => {
    tagName.textContent = (nameIn.value.trim() || "Vitalpilz-Mix").toUpperCase();
    tagName.removeAttribute("textLength"); tagName.removeAttribute("lengthAdjust");
    if (tagName.getComputedTextLength() > 78) { tagName.setAttribute("textLength", 78); tagName.setAttribute("lengthAdjust", "spacingAndGlyphs"); }
  };
  nameIn.addEventListener("input", () => { fitName(); kick(0, 8); });
  // polje za ime je skriveno dok ga kupac ne otvori
  const nameOpen = $("[data-name-open]"), nameBox = $("#blend-name-box");
  nameOpen.addEventListener("click", () => { nameBox.hidden = false; nameOpen.hidden = true; nameOpen.setAttribute("aria-expanded", "true"); nameIn.focus(); });
  document.fonts.ready.then(fitName);

  // za scenu: gdje je površina, talas i mjehurići na mjestu mlaza
  root.blendApi = {
    surfaceY: () => BOTTOM - order.reduce((s, n) => s + (anim.get(n) ? anim.get(n).x : 0), 0) * PX,
    kick: (a) => kick(a),
    bubbles: (x) => {
      const top = BOTTOM - order.reduce((s, n) => s + (anim.get(n) ? anim.get(n).x : 0), 0) * PX;
      for (let k = 0; k < 2; k++) bubbles.push({ x: x - 14 + Math.random() * 28, y: top + 14 + Math.random() * 30, r: (1 + Math.random() * 1.8).toFixed(1), s: 30 + Math.random() * 40, life: 0.5 + Math.random() * 0.5 });
      kick(0);
    },
  };
  commit("", 0);
  render();
}

initBlend();
})();
